// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleBindingModuleVersion } from './moduleBindingModuleVersion';

/**
 * Reference to a concrete module (with optional version).
 */
export interface ModuleBinding {
  module_id: string;
  /** Concrete module version or any */
  module_version?: ModuleBindingModuleVersion;
}
